import React from "react";
import ConfirmationDialog from "../ConfirmationDialog";
import * as api from "../../services/api";
import * as f from "../../utils/formatter";
import { status } from "shared/src/appointment.mjs";
import { useSnackbarMessage } from "../Snackbar.jsx";

/**
 * @typedef Client
 * @property {string} first_name
 * @property {string} last_name
 *
 * @typedef Appointment
 * @property {string} id
 * @property {Client} client
 */

/**
 * @param {object} props
 * @param {Appointment[]} props.appointments
 * @param {() => void} props.close
 */
export default function CancelOrWaitAppointmentDialog({ appointments, close }) {
  const displaySnackbarMessage = useSnackbarMessage();

  return (
    <>
      <ConfirmationDialog
        title="Vrácení do čekárny"
        content={`Opravdu chcete klienta ${appointments
          .map((appointment) => f.fullName(appointment.client))
          .join(", ")} vrátit zpět do čekárny?`}
        onDecision={async (decision) => {
          close();

          if (decision) {
            await api
              .patchAppointments(
                appointments.map((appointment) => ({
                  id: appointment.id,
                  status_id: status.WAITING,
                  actual_calendar_id: null,
                  employee_id: null,
                })),
              )
              .then(({ errors, data }) => {
                if (data && data.patchAppointments) {
                  displaySnackbarMessage({
                    title: "Klient byl úspěšně vrácen do čekárny.",
                    content: "",
                  });
                } else if (errors && errors.length > 0) {
                  displaySnackbarMessage({
                    title: "Nepodařilo se vrátit klienta do čekárny",
                    severity: "error",
                    content: errors.join(", "),
                  });
                }
              });
          }
        }}
      />
    </>
  );
}
